import styled from 'styled-components';
import React from 'react';
import {
  Button,
  SectionParent,
  H1,
  H2,
  BlueButton,
} from '../../StyledComponents';
// import Arrow from '../../../assets/v2/homepagedevsection/arrow.svg';
// import DeveloperHero from '../../../assets/v2/png/developer_hero.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Title } from '../HomePage/HomepageSectionOne';
import Ide from '../../../assets/v2/Developer/Ide.svg';
import Test from '../../../assets/v2/Developer/Test.svg';
import Simulate from '../../../assets/v2/Developer/Simulate.svg';
import Virtual from '../../../assets/v2/Developer/Virtual.png';
import Sdk from '../../../assets/v2/Developer/Sdk.svg';
// import Hero from '../../lottieAnimations/Hero.json'
// import lottie, { AnimationItem } from 'lottie-web';

const AndroidTitle = styled(Title)`
  color: #66d1b1;
  font-size: 36px;
  line-height: normal;
  font-weight: bold;
  text-align: center;
  margin-top: 5rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const FromManufacturingT = styled.h2`
  font-size: 18px;
  line-height: normal;
  color: #d1d7ea;
  text-align: center;
  width: 60%;
  margin-left: 20%;
  margin-top: 16px;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    width: 100%;
    padding: 0 3rem;
    line-height: 1.5;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;

const SectionAndroid = styled(SectionParent)`
  background: #0f1a3e;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  @media (min-width: 1500px) {
    margin-left: 0rem;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  padding-top: 2rem;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    padding-bottom: 1rem;
  }
  @media (min-width: 1500px) {
    width: 115%;
    margin-left: 2rem;
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 80%;
  align-self: center;
  grid-column: span 2;
  margin-left: 4rem;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const SectionAndroidContent = styled(H2)`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #99bee3;
  width: 100%;
  padding-top: 0.5rem;
  text-align: justify;
  // margin-left: 2.5rem;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
    margin-right: 4rem;
    margin-bottom: 1rem;
    font-size: 14px;
  }
  @media (min-width: 1500px) {
    font-size: 16px;
    width: 80%;
  }
`;
const SectionTitle = styled(H1)`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  @media (max-width: 520px) {
    text-align: center;
    margin-right: 4rem;
  }
`;

const TargetImage = styled(LazyLoadImage)`
  width: 550px;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
  @media (min-width: 1500px) {
    width: 170%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  margin-left: 3rem;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
  @media (max-width: 520px) {
    padding-bottom: 2rem;
    margin: 0 auto;
  }
`;

const ImgDescription = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #06be87;
  text-align: center;
  margin-top: 2rem;
`;

const GreenButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: center;
  display: flex;
  margin-top: 10px;
  margin-bottom: 0rem;
  margin-right: 4rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
  @media (max-width: 520px) {
    margin: 1rem auto;
  }
`;

const GreenButtonNew = styled(BlueButton)`
  background: #02b875;
  width: 100% @media (max-width: 520px) {
    font-size: 16px;
  }
  @media (max-width: 320px) {
    font-size: 14px;
  }
`;

export class Android extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      first: true,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <div>
        <AndroidTitle>Android Development Tools</AndroidTitle>
        <FromManufacturingT>
          Unlock a smarter approach to single-purpose Android app
          <br />
          development with Esper’s Android Studio integration.
        </FromManufacturingT>
        <SectionAndroid>
          {this.state.width > 678 ? (
            <Grid
              style={
                this.state.width > 1500
                  ? {
                      marginLeft: '6rem',
                    }
                  : {}
              }
            >
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-6rem',
                      }
                    : { display: 'grid' }
                }
              >
                <TargetImage src={Ide} />
                <ImgDescription>
                  What are you waiting for? It takes 2 minutes (or less) to
                  power up your IDE.
                </ImgDescription>
                <GreenButtonWrapper>
                  <a href="https://docs.esper.io/home/esperplugin.html">
                    <GreenButtonNew>Power up your IDE</GreenButtonNew>
                  </a>
                </GreenButtonWrapper>
              </ImgWrapper>
              <GridItem>
                <SectionTitle>Power Up Android Studio IDE</SectionTitle>
                <SectionAndroidContent>
                  Transform your IDE into a launchpad for single-purpose device
                  domination.
                  <br />
                  <br />
                  With Esper, you can develop, test, and deploy apps for ALL
                  Android form factors.
                </SectionAndroidContent>
              </GridItem>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Power Up Android Studio IDE</SectionTitle>
                <SectionAndroidContent>
                  Transform your IDE into a launchpad for single-purpose device
                  domination.
                  <br />
                  <br />
                  With Esper, you can develop, test, and deploy apps for ALL
                  Android form factors.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImage src={Ide} />
                <ImgDescription>
                  What are you waiting for? It takes 2 minutes (or less) to
                  power up your IDE.
                </ImgDescription>
                <GreenButtonWrapper>
                  <a href="https://docs.esper.io/home/esperplugin.html">
                    <GreenButtonNew>Power up your IDE</GreenButtonNew>
                  </a>
                </GreenButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
          <Grid>
            <GridItem
              style={
                this.state.width > 1500
                  ? {
                      marginRight: '8rem',
                      marginLeft: '-15rem',
                    }
                  : { justifyContent: 'center' }
              }
            >
              <SectionTitle>Test Continously, Fail Faster</SectionTitle>
              <SectionAndroidContent>
                Access diagnostics and debugging for each stage of the app
                development pipeline.
                <br />
                <br />
                Unlock remote troubleshooting for field devices.
              </SectionAndroidContent>
            </GridItem>
            <ImgWrapper
              style={
                this.state.width > 1500
                  ? {
                      marginRight: '6rem',
                      marginLeft: '-4rem',
                    }
                  : { display: 'grid' }
              }
            >
              <TargetImage
                style={this.state.width > 1500 ? { width: '150%' } : {}}
                src={Test}
              />
              <GreenButtonWrapper>
                <a href="https://docs.esper.io/home/esperplugin.html#esper-android-virtual-device">
                  <GreenButtonNew>Unleash CI/CD</GreenButtonNew>
                </a>
              </GreenButtonWrapper>
            </ImgWrapper>
          </Grid>
          {this.state.width > 678 ? (
            <Grid
              style={
                this.state.width > 1500
                  ? {
                      marginLeft: '6rem',
                    }
                  : {}
              }
            >
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-6rem',
                      }
                    : { justifyContent: 'center' }
                }
              >
                <TargetImage src={Simulate} />
                <GreenButtonWrapper>
                  <a href="https://docs.esper.io/home/esperplugin.html#deploying-application-to-a-group-of-devices">
                    <GreenButtonNew>Catalog Your Apps</GreenButtonNew>
                  </a>
                </GreenButtonWrapper>
              </ImgWrapper>
              <GridItem>
                <SectionTitle>Manage Android Apps</SectionTitle>
                <SectionAndroidContent>
                  Create a single library of apps &
                  {this.state.width > 1500 ? <br /> : null} app versions.
                  <br />
                  <br />
                  Archive your work with Esper's easy bulk uploader.
                </SectionAndroidContent>
              </GridItem>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Manage Android Apps</SectionTitle>
                <SectionAndroidContent>
                  Create a single library of apps & app versions.
                  <br />
                  <br />
                  Archive your work with Esper's easy bulk uploader.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImage src={Simulate} />
                <GreenButtonWrapper>
                  <a href="https://docs.esper.io/home/esperplugin.html#deploying-application-to-a-group-of-devices">
                    <GreenButtonNew>Catalog Your Apps</GreenButtonNew>
                  </a>
                </GreenButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
          <Grid>
            <GridItem
              style={
                this.state.width > 1500
                  ? {
                      marginRight: '8rem',
                      marginLeft: '-15rem',
                    }
                  : { justifyContent: 'center' }
              }
            >
              <SectionTitle>Simulate Real-World Performance</SectionTitle>
              <SectionAndroidContent>
                You can officially quit provisioning test devices with Esper’s
                AVDs for Android Studio.
                <br />
                <br />
                Plus, you can test-drive our custom Android OS, Esper Enhanced
                Android, from your IDE.
              </SectionAndroidContent>
            </GridItem>
            <ImgWrapper
              style={
                this.state.width > 1500
                  ? {
                      marginRight: '6rem',
                      marginLeft: '-4rem',
                    }
                  : { display: 'grid' }
              }
            >
              <TargetImage
                style={this.state.width > 1500 ? { width: '150%' } : {}}
                src={Virtual}
              />
              <GreenButtonWrapper>
                <a href="https://docs.esper.io/home/esperplugin.html#esper-android-virtual-device">
                  <GreenButtonNew>Create a Virtual Device</GreenButtonNew>
                </a>
              </GreenButtonWrapper>
            </ImgWrapper>
          </Grid>
          {this.state.width > 678 ? (
            <Grid
              style={
                this.state.width > 1500
                  ? {
                      marginLeft: '6rem',
                    }
                  : {}
              }
            >
              <ImgWrapper
                style={
                  this.state.width > 1500
                    ? {
                        marginRight: '8rem',
                        marginLeft: '-6rem',
                      }
                    : { display: 'grid' }
                }
              >
                <TargetImage src={Sdk} />
                <GreenButtonWrapper>
                  <a href="https://docs.esper.io/home/devicesdk.html">
                    <GreenButtonNew>Put Python to Work</GreenButtonNew>
                  </a>
                </GreenButtonWrapper>
              </ImgWrapper>
              <GridItem>
                <SectionTitle>Esper Python SDK</SectionTitle>
                <SectionAndroidContent>
                  The Device SDK exposes an API so Android devs can seamlessly
                  perform privileged operations on managed devices.
                  <br />
                  <br />
                  Now, you can develop apps for seamless operations or retrieve
                  remote device info.
                </SectionAndroidContent>
              </GridItem>
            </Grid>
          ) : (
            <Grid>
              <GridItem>
                <SectionTitle>Esper Python SDK</SectionTitle>
                <SectionAndroidContent>
                  The Device SDK exposes an API so Android devs can seamlessly
                  perform privileged operations on managed devices.
                  <br />
                  <br />
                  Now, you can develop apps for seamless operations or retrieve
                  remote device info.
                </SectionAndroidContent>
              </GridItem>
              <ImgWrapper>
                <TargetImage src={Sdk} />
                <GreenButtonWrapper>
                  <a href="https://docs.esper.io/home/devicesdk.html">
                    <GreenButtonNew>Put Python to Work</GreenButtonNew>
                  </a>
                </GreenButtonWrapper>
              </ImgWrapper>
            </Grid>
          )}
        </SectionAndroid>
      </div>
    );
  }
}

export default Android;
